'use client';

import React from 'react';

interface StatItem {
  value: string;
  label: string;
}

interface StatsSectionProps {
  stats: StatItem[];   // from demo_data.stats
}

export default function StatsSection({ stats }: StatsSectionProps) {
  return (
    <div className="py-8 border-y" style={{ borderColor: "rgba(200,135,42,.15)", background: "rgba(45,24,16,.4)" }}>
      <div data-reveal data-stagger className="max-w-7xl mx-auto px-8 md:px-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {stats.map((stat, idx) => (
          <div key={idx}>
            <div className="text-3xl font-black mb-1" style={{ color: "var(--gold)", fontFamily: "'Playfair Display', serif" }}>
              {stat.value}
            </div>
            <div className="text-xs tracking-wider uppercase opacity-50">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}